module.exports = __webpack_public_path__ + "img/mn.e7cf2ce7.svg";